import {defineStore} from 'pinia'
import {checkoutAttempt, completeCheckoutAttempt} from '~/services/checkoutAttempt'
import {rememberOrderPaymentAccess} from '~/services/orderPaymentAccess'
import type {OrderInterface, OrderRequestInterface} from '~~/server/types/OrderInterface'

export const useOrdersStore = defineStore('order', {
    state: () => ({
        _orders: [] as OrderInterface[],
        _promise: null as Promise<OrderInterface> | null,
    }),
    getters: {
        orders: (state) => state._orders,
    },
    actions: {
        async orderSave(orderRequest: OrderRequestInterface): Promise<OrderInterface> {
            if (this._promise) return this._promise
            const promise = (async () => {
                try {
                    const { $api } = useNuxtApp()
                    const key = orderRequest.checkout_key ?? await checkoutAttempt('b2c_checkout_attempt', orderRequest)
                    const result = await $api<OrderInterface>('orders', {
                        method: 'POST',
                        body: { ...orderRequest, checkout_key: key },
                    });
                    rememberOrderPaymentAccess(result)
                    completeCheckoutAttempt('b2c_checkout_attempt', key)
                    return result
                }
                catch (error: any) {
                    throw error
                }
                finally {
                    this._promise = null
                }
            })()
            this._promise = promise
            return promise
        },
    },
})
